import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PiBuilderService } from "./pi-builder.service";
import { CalculatorSettingsService } from "./../calculatorsettings/calculator-settings.service";
import { PiActiveFilter } from "./../pi-filter/pi-active.filter";
import { PiSettingFilter } from "./../pi-filter/pi-setting.filter";
import { PiWhitelistFilter } from "./../pi-filter/pi-whitelist.filter";
import { PiBlacklistFilter } from "./../pi-filter/pi-blacklist.filter";
import { IParticipatingInsurer } from "../../models/participating-insurer.model";
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: "root"
})
export class PiBootstrapService {
    participatingInsurerSettings = null;
    currentDate = null;
    piList = null;
    constructor(
        private piBuilderService: PiBuilderService,
        private calculatorSettingsService: CalculatorSettingsService,
        private http: HttpClient
    ) {
        this.participatingInsurerSettings = this.calculatorSettingsService.participatingInsurerSettings;
    }

    current(currentDate) {
        this.currentDate = currentDate;
    }

    settings(participatingInsurerSettings) {
        this.participatingInsurerSettings = participatingInsurerSettings;

        return this;
    }

    generate(): any[] {
        if (!this) {
            return;
        }

        if (!window["piBlacklist"]) {
            window["piBlacklist"] = [];
        }
        window["piBlacklist"].push("Liberty Agency");

        return this.piBuilderService.reset()
            .add(this.piList)
            .add(this.piBuilderService.defaultOther(""))
            .filter(new PiActiveFilter().input(this.currentDate))
            .filter(new PiSettingFilter().input(this.participatingInsurerSettings))
            .filter(new PiBlacklistFilter().input(window["piBlacklist"]))
            .filter(new PiWhitelistFilter().input(window["piWhitelist"]))
            .build(this.piList)
            .sort()
            .getNames();
    }

    getPiListFromServer(): Observable<IParticipatingInsurer[]> {
        // @ts-ignore
        const headers: HttpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            'ocp-apim-subscription-key': environment.ocp_apim_subscription_key
        });
        const options = {
            headers: headers
        };

        return this.http.get<IParticipatingInsurer[]>(environment.pilisturl, options);
    }

    storePiListAsync(fn: CallableFunction): void {
        this.getPiListFromServer().subscribe(data => {
            this.piList = this.libertyTransform(data);

            if (fn) {
                fn();
            }
        });
    }

    libertyTransform(data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i]["Name"] == "Liberty Direct") {
                data[i]["Name"] = "Liberty Mutual Corporation";
            }
        }

        return data;
    }

    isLoaded(): boolean {
        return this.piList ? true : false;
    }
}
